import React, { useState, Fragment } from 'react';
import { isPresent } from 'utils/helperMethods';
import { useTranslation } from 'react-i18next';
import Seo from 'sharedComponents/Seo';
import { Route, Switch } from 'react-router';
import { appRoutes } from 'routes';

import LocationSelect from './components/LocationSelect';
import LoanOfficerSelect from './components/LoanOfficerSelect';
import SurveyPage from './components/SurveyPage';

const BuyerLoanOfficerSearchSurvey = () => {
  const { t } = useTranslation();
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedLoanOfficer, setSelectedLoanOfficer] = useState(null);

  const isLocationSelected = isPresent(selectedLocation);

  const handleSelect = location => setSelectedLocation(location);
  const handleSelectLoanOfficer = loanOfficer => setSelectedLoanOfficer(loanOfficer);

  return (
    <Fragment>
      <Seo title={t('meta.LoanOfficerSearchSurvey.title')} />
      <Switch>
        <Route
          path={appRoutes.loanOfficerSearchSurveyListPath()}
          render={() => (
            <LoanOfficerSelect
              location={selectedLocation}
              onSelectLocation={handleSelect}
              onSelectLoanOfficer={handleSelectLoanOfficer}
            />
          )}
        />
        <Route
          path={appRoutes.loanOfficersSearchSurveyWizardPath()}
          render={() => <SurveyPage location={selectedLocation} loanOfficer={selectedLoanOfficer} />}
        />
        <Route
          path={appRoutes.loanOfficerSearchSurveyRootPath()}
          render={() => <LocationSelect isSelected={isLocationSelected} onSelect={handleSelect} />}
        />
      </Switch>
    </Fragment>
  );
};

export default BuyerLoanOfficerSearchSurvey;



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/BuyerLoanOfficerSearchSurvey.js